/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Watchers_watches = {
    readonly nodes: ReadonlyArray<{
        readonly contactSlug: string;
        readonly contactItem: {
            readonly title: string;
            readonly image: {
                readonly url: string | null;
            } | null;
        };
    } | null> | null;
    readonly " $refType": "Watchers_watches";
};
export type Watchers_watches$data = Watchers_watches;
export type Watchers_watches$key = {
    readonly " $data"?: Watchers_watches$data;
    readonly " $fragmentRefs": FragmentRefs<"Watchers_watches">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Watchers_watches",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemWatch",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contactSlug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ListItem",
          "kind": "LinkedField",
          "name": "contactItem",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "image",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemWatchConnection",
  "abstractKey": null
};
(node as any).hash = '6bb0284ad04d304ab7b8e226ed5ecd4d';
export default node;
